export default function SendToComponent(props) {
  return<div>SendToComponent</div>;
}
